var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{class:_vm.$style.dateCard,style:(_vm.cssVars),attrs:{"flat":"","color":"transparent"}},[_c('v-card-subtitle',{staticClass:"pa-0",class:_vm.$style.dateCardLabel},[_vm._v(_vm._s(_vm.label))]),_c('v-card-title',{staticClass:"pa-0",class:_vm.$style.dateCardValue},[_c('core-time',{attrs:{"time":_vm.value,"format":_vm.format}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }